import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function CustomerPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20clean%20home%20interior%20with%20happy%20family%20using%20smartphone%20to%20book%20home%20services%2C%20bright%20natural%20lighting%2C%20purple%20and%20white%20color%20scheme%2C%20professional%20photography%20style%2C%20clean%20minimalistic%20background%2C%20contemporary%20home%20setting&width=1200&height=600&seq=customer-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              BNM makes daily life easier
            </h1>
            <p className="text-xl mb-8">
              Book trusted home services in 3 easy steps
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold">1</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Select your service</h3>
                <p className="text-purple-100">Choose from our wide range of home services</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold">2</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Pay a small advance online</h3>
                <p className="text-purple-100">Secure online payment with transparent pricing</p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold">3</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Sit back and relax</h3>
                <p className="text-purple-100">Our verified partner completes the job</p>
              </div>
            </div>

            {/* <button className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              Download Customer App
            </button> */}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16" id="services">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Services We Offer</h2>
            <p className="text-xl text-gray-600">All with just a tap</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-drop-line', name: 'Bathroom Cleaning Basic', desc: 'Basic bathroom cleaning and sanitization' },
              { icon: 'ri-shining-line', name: 'Bathroom Cleaning Intense', desc: 'Deep bathroom cleaning with scrubbing' },
              { icon: 'ri-brush-2-line', name: 'Dusting', desc: 'Complete dusting of home surfaces' },
              { icon: 'ri-home-heart-line', name: 'Sofa Cleaning', desc: 'Professional sofa and upholstery cleaning' },
              { icon: 'ri-eraser-line', name: 'Carpet Cleaning', desc: 'Deep carpet cleaning and stain removal' },
              { icon: 'ri-knife-line', name: 'Kitchen Utensil Cleaning', desc: 'Thorough cleaning of kitchen utensils' },
              { icon: 'ri-windy-line', name: 'Fan Cleaning', desc: 'Cleaning and dusting of fans' },
              { icon: 'ri-window-line', name: 'Window Cleaning', desc: 'Streak-free window and glass cleaning' },
              { icon: 'ri-restaurant-line', name: 'Cooking', desc: 'Personal chef services' },
              { icon: 'ri-filter-3-line', name: 'Water Filter', desc: 'Water filter servicing and maintenance' },
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow cursor-pointer border border-gray-100">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-xl text-purple-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{service.name}</h3>
                <p className="text-gray-600 text-sm">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Customers Love Us</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Verified Partners</h3>
              <p className="text-gray-600">For safety & reliability</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Live Tracking</h3>
              <p className="text-gray-600">Of service progress</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-rupee-circle-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Cashless Payments</h3>
              <p className="text-gray-600">Transparent pricing</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Quick Bookings</h3>
              <p className="text-gray-600">In under 2 minutes</p>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="py-16 bg-purple-50" id="download">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Download Our Customer App Today</h2>
            <p className="text-xl text-gray-600 mb-12">Available on both Android and iOS - book services in seconds</p>

            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <img src="https://bnm-content.s3.ap-south-1.amazonaws.com/images/customerapp.webp"
                  alt="Customer App Screenshots"
                  className="rounded-2xl shadow-lg mx-auto object-top" />
              </div>

              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Features:</h3>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Browse and book 50+ services</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Real-time partner tracking</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Secure payment gateway</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">24/7 customer support</span>
                  </li>
                </ul>

                <div className="mt-8 space-y-4">
                  <div className="flex flex-col sm:flex-row gap-4">
                    {/* Android Button */}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.baainearme.customerapp"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
                    >
                      <i className="ri-google-play-fill mr-2 text-xl"></i>
                      Download for Android
                    </a>

                    {/* iOS Button */}
                    <a
                      href="https://apps.apple.com/app/bnm/id6751604989"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
                    >
                      <i className="ri-app-store-fill mr-2 text-xl"></i>
                      Download for iOS
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Hear from Others</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-purple-50 rounded-xl p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                "BNM helped me book a cleaner within minutes – professional & affordable!"
              </p>
              <p className="font-semibold text-gray-800">– Sneha</p>
            </div>

            <div className="bg-purple-50 rounded-xl p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                "Super convenient. I don't worry when a partner is verified."
              </p>
              <p className="font-semibold text-gray-800">– Rahul</p>
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Got Questions?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Visit our FAQs on booking, rescheduling, cancellations, or payment support
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex items-center bg-white px-6 py-3 rounded-full shadow-sm">
              <i className="ri-phone-line text-purple-600 mr-2"></i>
              <span className="font-semibold">93074 19845</span>
            </div>
            <div className="flex items-center bg-white px-6 py-3 rounded-full shadow-sm">
              <i className="ri-mail-line text-purple-600 mr-2"></i>
              <span className="font-semibold">support@baainearme.com</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 420 160"
                className="h-10 text-white"   // change to text-purple-600 etc.
                role="img"
                aria-label="BNM · Baainearme"
              >
                <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
                  {/* Left ring */}
                  <circle cx="50" cy="60" r="40" />
                  {/* Vertical divider */}
                  <line x1="110" y1="20" x2="110" y2="120" />
                </g>

                {/* Text block */}
                <g fill="currentColor">
                  {/* BNM */}
                  <text
                    x="140"
                    y="72"
                    fontFamily="Poppins, Inter, Arial, sans-serif"
                    fontWeight="800"
                    fontSize="56"
                  >
                    BNM
                  </text>

                  {/* Baainearme */}
                  <text
                    x="140"
                    y="120"
                    fontFamily="Poppins, Inter, Arial, sans-serif"
                    fontWeight="700"
                    fontSize="32"
                  >
                    Baainearme
                  </text>
                </g>
              </svg>

              <p className="text-gray-400">
                Making daily life easier with trusted home services
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Customers</h3>
              <ul className="space-y-2 text-gray-400">

                <li><Link to="/customer-support" className="hover:text-white cursor-pointer">Customer Support</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/partner" className="hover:text-white cursor-pointer">Become Partner</Link></li>
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/faqs" className="hover:text-white cursor-pointer">FAQs</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
                <li><Link to="/customer-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
